import { SettingsProvider } from './../settings/settings';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigProvider } from '../config/config';
import { RequestProvider } from '../request/request';
import { SessionProvider } from '../session/session';
import { Storage } from '@ionic/storage';
import { EventProvider, Pager } from '../event/event';
import { StorageProvider } from '../storage-service/storage-service';
import { Cache } from '../../assets/data/cache-key/cache-key';
import { TranslateService } from '@ngx-translate/core';

/*
  Generated class for the ResultProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export interface ResultSearchModel {
  sw: string;
  cid: string;
  page?: string;
  start?: string;
  limit?: string;
}

export interface RanglistSearchModelByID {
  eid: number,
  page: number,
  start: number,
  limit: number
}

export interface ResultSearchAdvancedModel {
  eid: string; //event id
  ena: string; //event name
  city: string;
  dt: string; //date
  dist: string; //distane
  t: string; //type
  sw: string; //athlete name
  page?: string;
  start?: string;
  limit?: string;
}

export interface RanglistSearchModel {
  eid: string;
  page?: string;
  start?: string;
  limit?: string;
}
export interface ResultListModel {
  athleteId: number;
  athleteName: string;
  cid: number;
  eventDate: number;
  eventId: number;
  eventName: string;
  gplatz: number;
  gtime: number;
  hasDatum: boolean;
  hasPlatz: boolean;
  hasStrecke: boolean;
  hasZeit: boolean;
  id: number;
  picName: string;
  resultText: string;
  strecke1: number;
  strecke2: number;
  strecke3: number;
  streckeconv: string;
  trophyColor: string;
  trophyMaterial: string;
  trophyType: string;
}

export interface RanglistListModel {
  athleteId: number;
  athleteName: string;
  cid: number;
  eventId: number;
  id: number;
  picName: string;
  place: number;
  strecke1: number;
  strecke2: number;
  strecke3: number;
  streckeconv: string;
  timeFormatted: string;
  lid?: number;
}

export interface ResultCreateModel {
  area: string;
  cid: number;
  city: string;
  country: string;
  ena: string;
  eventDate: string;
  picName: string;
  place: number;
  resulttime: string;
  strecke: string;
  type: string;
  zip: string;
}

@Injectable()
export class ResultProvider {
  constructor(public request: RequestProvider, private settingsService: SettingsProvider, private translate: TranslateService, private storage: Storage, private strg: StorageProvider, public config: ConfigProvider, private sessionService: SessionProvider,
    public eventService: EventProvider
  ) {
  }

  async searchResults(rawParams: ResultSearchModel, shouldIterate: boolean = true): Promise<ResultListModel[]> {
    console.log('rawParams: ', rawParams);
    if (rawParams.page === null || !shouldIterate) {
      rawParams.page = 1 + '';
      rawParams.limit = 25 + '';
      rawParams.start = 25 + '';
    } else {
      rawParams.page = parseInt(rawParams.page) + 1 + '';
      rawParams.start = parseInt(rawParams.start) + 25 + '';
    }
    if (!navigator.onLine) return this.strg.getSaved(Cache.SEARCH_RESULTS).then(r => r);
    else return this.request.getApiSimple<ResultListModel[]>('event/results/search', rawParams).then(r => {
      this.strg.saveData(r, Cache.SEARCH_RESULTS);
      return r;
    });
  }

  isDonate: boolean = false;
  lastEventId: any = null;
  async clientSearchResults(rawParams: any, specialRequest: boolean = false, appId: string = ""): Promise<RanglistListModel[]> {
    if (this.isDonate) return this.getDonateResults(rawParams);
    else {
      if (rawParams.page === null) {
        rawParams.page = 1 + '';
        rawParams.limit = 25 + '';
        rawParams.start = 0 + '';
      } else {
        rawParams.page = parseInt(rawParams.page) + 1 + '';
        rawParams.start = parseInt(rawParams.start) + 0 + '';
      }

      rawParams.lid = (await this.config.config).client.lid + '';
      if (!navigator.onLine) return this.strg.getSaved(Cache.SEARCH_RESULTS_CLIENT).then(r => r);
      else {
        if (specialRequest) {
          return this.request.getApiSimple<RanglistListModel[]>('athp', rawParams).then(r => {
            this.strg.saveData(r, Cache.SEARCH_RESULTS_CLIENT);
            return r;
          });
        } else {
          let url = 'event/results/search';
          if (typeof rawParams.lid != undefined) {
            url = `user/${rawParams.lid}/results/list`;
            delete rawParams.lid;
          }
          return this.request.getApiSimple<RanglistListModel[]>(url, rawParams).then(r => {
            this.strg.saveData(r, Cache.SEARCH_RESULTS_CLIENT);
            return r;
          });
        }
      }
    }
  }

  async getDonateResults(rawParams: any) {
    console.log("getDonateResults: /resultlstspenden");
    if (!this.lastEventId || typeof this.lastEventId == undefined) {
     await this.eventService.getEventId(rawParams.ena, '', rawParams.dt, rawParams.cid).then(id => {
        this.lastEventId = id;
      })
    }
    if (rawParams.page === null) {
      rawParams.page = 1 + '';
      rawParams.limit = 10 + '';
      rawParams.start = 10 + '';
    } else {
      rawParams.page = parseInt(rawParams.page) + 1 + '';
      rawParams.start = parseInt(rawParams.start) + 10 + '';
    }
    if (!navigator.onLine) return this.strg.getSaved(Cache.RANGLIST_THURNAU).then(r => r);

    return this.request.getApiSimple<RanglistListModel[]>(`event/${this.lastEventId}/results/donation?page=${rawParams.page}&start=${rawParams.start}&limit=${rawParams.limit}`, null).then(r => {
      this.strg.saveData(r, Cache.RANGLIST_THURNAU);
      return r;
    });
  }

  getResultEventId(params) {
    return this.request.getApiSimple<RanglistListModel[]>(`event/results/event-id?ena=${params.ena}&city=&dt=${params.dt}&distance=${params.distance}&type=${params.type}&cid=${params.cid}`, null).then(r => {
      return r;
    });
  }

  async getRangList(rawParams: RanglistSearchModel): Promise<RanglistListModel[]> {
    let eid = rawParams.eid;
    if (rawParams.page === null) {
      rawParams.page = 1 + '';
      rawParams.limit = 25 + '';
      rawParams.start = 25 + '';
    } else {
      rawParams.page = parseInt(rawParams.page) + 1 + '';
      rawParams.start = parseInt(rawParams.start) + 25 + '';
    }
    delete rawParams.eid;
    if (!navigator.onLine) return this.strg.getSaved(Cache.RANGLIST).then(r => r);
    else return this.request.getApiSimple<RanglistListModel[]>(`event/${eid}/results`, rawParams).then(r => {
      this.strg.saveData(r, Cache.RANGLIST);
      return r;
    });
  }

  async getTotalList(rawParams: any): Promise<RanglistListModel[]> {
    // if (rawParams.page === null) {
    rawParams.page = 1 + '';
    rawParams.limit = 25 + '';
    rawParams.start = 25 + '';
    // }
    // else {
    //   rawParams.page = parseInt(rawParams.page) + 1 + '';
    //   rawParams.start = parseInt(rawParams.start) + 25 + '';
    // }
    if (!navigator.onLine) return this.strg.getSaved(Cache.TOTAL_LIST).then(r => r);
    else return this.request.getApiSimple<RanglistListModel[]>('event/results/teams/total', rawParams).then(r => {
      this.strg.saveData(r, Cache.TOTAL_LIST);
      return r;
    });
  }

  async getTeamList(rawParams: any): Promise<RanglistListModel[]> {
    // if (rawParams.page === null) {
    rawParams.page = 1 + '';
    rawParams.limit = 25 + '';
    rawParams.start = 25 + '';
    // }
    // else {
    // rawParams.page = parseInt(rawParams.page) + 1 + '';
    // rawParams.start = parseInt(rawParams.start) + 25 + '';
    // }
    if (!navigator.onLine) return this.strg.getSaved(Cache.RANGLIST_ID).then(r => r);
    else return this.request.getApiSimple<RanglistListModel[]>('event/results/teams', rawParams).then(r => {
      this.strg.saveData(r, Cache.RANGLIST_ID);
      return r;
    });
  }

  async getRangListById(rawParams: RanglistSearchModelByID): Promise<RanglistListModel[]> {
    let eid = rawParams.eid;
    if (rawParams.page === null) {
      rawParams.page = 1;
      rawParams.limit = 25;
      rawParams.start = 25;
    } else {
      rawParams.page = rawParams.page + 1;
      rawParams.start = rawParams.start + 25;
    }
    delete rawParams.eid;
    if (!navigator.onLine) return this.strg.getSaved(Cache.RANGLIST).then(r => r);
    else return this.request.getApiSimple<RanglistListModel[]>(`event/${eid}/results`, rawParams).then(r => {
      this.strg.saveData(r, Cache.RANGLIST);
      return r;
    });
  }

  async createResult(result: ResultCreateModel): Promise<boolean> {
    let lang = this.translate.getDefaultLang();
    return this.sessionService.getToken().then(async token => {
      return this.request.createPostPromise<boolean>((await this.config.urlConfig()).baseUrl + `user/${token}/event/result/insert`, result, { lang: lang });
    });
  }

  async addComment(resultId, comment): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.sessionService.getToken(false, false).then(async (token: string) => {
        this.request.getApiSimple<boolean>(`user/${token}/comment/${resultId}/add`, { comment: comment }, null, "event")
          .then(() => resolve(true))
          .catch((err) => console.log());
      });
    });
  }

  async getEndurances(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.settingsService.getActiveLanguage().then(async lang => {
        if (!lang) lang = "de";
        lang = lang.includes("de" || "De") ? "de" : "en";
        let url = ((await this.config.urlConfig()).training + 'categories/trackable/' + lang);
        console.log('getEndurances-0');
        if (!navigator.onLine) this.strg.getSaved(Cache.ENDURANCES_SIMPLE).then(r => resolve(r));
        else this.request.get(url)
          .toPromise()
          .then((data: any) => {
            this.strg.saveData(data, Cache.ENDURANCES_SIMPLE);
            resolve(data);
          })
          .catch((err) => {
            console.log('endurances fetch error');
            resolve([]);
          });
      });
    });
  }

  async deleteComment(spid, resultId): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.sessionService.getToken().then(token => {
        this.request.getApiSimple<boolean>(`user/${token}/comment/${resultId}/delete`, { lastModified: new Date().getTime() }, 2000, "event")
          .then((data) => {
            resolve(true);
          })
          .catch((err) => {
            resolve(false)
          });
      });
    });
  }

  async getElevationResults(url): Promise<any> {
    return new Promise((resolve, reject) => {

      let httpParams = new HttpParams();
      httpParams = httpParams.append("Access-Control-Allow-Origin", "*");
      httpParams = httpParams.append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");

      this.request.get(url, { params: httpParams, reportProgress: true }).toPromise().then((result) => resolve(result)).catch((err) => reject(err));
    });
  }

  async sendVirtualResults(obj, distance?): Promise<any> {
    return new Promise((resolve, reject) => {
      this.sessionService.getToken(false, false).then(token => {
        let httpParams = new HttpParams();
        console.log("route data save: ");
        console.log(JSON.stringify(obj));
        httpParams = httpParams.append('pj', obj);
        if (distance) httpParams = httpParams.append('distMeter', distance);
        let endpoint = (distance) ? `user/${token}/result/save/withdistance` : `user/${token}/result/save`;
        if (!navigator.onLine) this.strg.getSaved(endpoint + token).then(r => resolve(true));
        else return this.request
          .createPostApiPromise(endpoint, obj, { params: httpParams })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            resolve(false);
          });
      });
    });
  }

  async sendVirtualResultsNoCheck(obj): Promise<any> {
    console.log('obj: ', obj);
    return new Promise((resolve, reject) => {
      this.sessionService.getToken(false, false).then(token => {
        let httpParams = new HttpParams();
        // httpParams = httpParams.append('token', token);
        httpParams = httpParams.append('pj', obj);
        if (!navigator.onLine) this.strg.getSaved("SAVEVRESULTN" + token).then(r => resolve(r));
        else return this.request
          .createPostApiPromise(`user/${token}/result/save/nocheck`, obj, { params: httpParams })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            resolve(false);
          });
      });
    });
    // return this.request.createPostApiPromise<boolean>('savevresult', obj, {});
  }

  async getCategoriesWithResultsByLid(lid: any) {
    if (!navigator.onLine) return this.strg.getSaved(Cache.CATS_RESULTS_LID + lid).then(r => r);
    else return this.request.getApiSimple<any[]>(`user/${lid}/events/categories`).then(r => {
      this.strg.saveData(r, Cache.CATS_RESULTS_LID + lid);
      return r;
    });
  }

  saveRoute(token, route) {
    return fetch(`https://spooorts.de/route/user/${token}/route/save`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(route)
    }).then(response => {
      if (response.ok) {
        console.log('Successfully saved!');
        return true;
      } else {
        console.log('Image not uploaded due to some error!');
        return false;
      }
    }).catch(err => {
      if (err.status === 400 || err.status === 401) {
        alert(err.error.message);
        return false;
      }
    });
  }

  async sendAddResult(obj): Promise<any> {
    return new Promise((resolve, reject) => {
      this.sessionService.getToken().then(token => {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('pj', JSON.stringify(obj));
        if (!navigator.onLine) this.strg.getSaved("SAVEVRESULTN").then(r => resolve(r));
        else return this.request
          .createPostApiPromise(`user/${token}/result/save/nocheck`, null, { params: httpParams })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            resolve(false);
          });
      });
    });
    // return this.request.createPostApiPromise<boolean>('savevresult', obj, {});
  }

  async getComments(resultId, page, start, limit): Promise<any> {
    if (page === null) {
      page = 1 + '';
      start = 0 + '';
      limit = 100 + '';
    } else {
      page = parseInt(page) + 1 + '';
      start = parseInt(start) + 100 + '';
    }
    if (!navigator.onLine) this.strg.getSaved("COMMENTS" + resultId).then(r => r);
    else return this.request.getApiSimple<any>(`comments/${resultId}`, { page: page, start: start, limit: limit }, 2000, "event").then(results => {
      this.strg.saveData(results, "COMMENTS" + resultId);
      return results
    })
  }

  async getFans(resultId, page, start, limit): Promise<any> {
    if (page === null) {
      page = 1 + '';
      start = 0 + '';
      limit = 100 + '';
    } else {
      page = parseInt(page) + 1 + '';
      start = parseInt(start) + 100 + '';
    }
    let lang = this.translate.getDefaultLang();
    if (!navigator.onLine) return this.strg.getSaved("rfans" + resultId).then(r => r);
    else return this.request.getApiSimple<any>(`event/result/${resultId}/fans`, { lang: lang, page: page, start: start, limit: limit }).then(r => {
      this.strg.saveData(r, "rfans" + resultId);
      return r;
    })
  } 

  getTrophyType(): Promise<TrophyType[]> {
    return this.request.getSimple<TrophyType[]>('assets/data/trophy/type.json');
  }

  getTrophyColor(): Promise<TrophyColor[]> {
    return this.request.getSimple<TrophyColor[]>('assets/data/trophy/color.json');
  }

  getTrophyMaterial(): Promise<TrophyMaterial[]> {
    return this.request.getSimple<TrophyMaterial[]>('assets/data/trophy/material.json');
  }

  updateTrophy(rawParams: TrophyUpdate): Promise<boolean> {
    return this.sessionService.getToken().then(token => {
      return this.request
        .getApiSimple(`user/${token}/event/result/${rawParams.resultId}/trophy/save`, rawParams)
        .then(() => true)
        .catch(() => false);
    });
  }

  congrat(id: number): Promise<any> {
    return this.sessionService.getToken().then(token => {
      return this.request
        .getApiSimple(`user/${token}/congratulation/${id}/add`)
        .then((data) => data)
        .catch((err) => console.log(err));
    });
  }

  removeCongrat(resultId): Promise<any> {
    return this.sessionService.getToken().then(token => {
      return this.request.getApiSimple(`user/${token}/congratulation/${resultId}/delete`)
        .then((data) => data)
        .catch((err) => console.log(err));
    });
  }

  getResultTypeAPIName(name: string, type: string) {

    if (name.toLocaleUpperCase().includes("RUN"))
      return "Run" + type;
    else if (name.toLocaleUpperCase().includes("BIKE"))
      return "RoadBike" + type;
    else if (name.toLocaleUpperCase().includes("SWIM"))
      return "Swim" + type;
    else if (name.toLocaleUpperCase().includes("TRI"))
      return "Tri" + type;
    else if (name.toLocaleUpperCase().includes("VIR"))
      return "Run" + type;

  }

  async getResult(id: number, cid?: number): Promise<ResultListModel> {
    if (!navigator.onLine) return this.strg.getSaved("result" + id).then(r => r);
    else return this.request.getApiSimple<ResultListModel>(`event/result/${id}/details`, { cid: cid + '' }).then(r => {
      this.strg.saveData(r, "result" + id);
      return r;
    });
  }

  async getNearbyTimes(id: number): Promise<any[]> {
    return this.request.getApiSimple<any[]>(`events/${id}/default-times`);
  }
}

export interface TrophyUpdate {
  hasDatum: boolean;
  hasPlatz: boolean;
  hasStrecke: boolean;
  hasZeit: boolean;
  trophyType: string;
  trophyColor: number;
  trophyMaterial: number;
  resultId: number;
}

export interface TrophyType {
  name: string;
  pokal: string;
  modelName: string;
}

export interface TrophyColor {
  id: number;
  name: string;
}

export interface TrophyMaterial {
  id: number;
  name: string;
  img: string;
}

export interface ResultTIme {
  time: number;
}

// Statistics of the run for each user per certain event
// each km the time is recordered
export interface StatisticsResults {
  eventName: string;
  userId: string;
  eventId: number;
  eventCid: number;
  totalTime: string;
  totalDistance: number;
  statistics: {
    km: number;
    time: number;
    timeConverted: string;
    elevation: any;
    coords: any;
  }[];
  map: {
    points: any[];
  }
}



// WEBPACK FOOTER //
// /src/providers/result/result.ts